// Definition taken from: https://github.com/springload/draftail/blob/master/examples/constants/ui.js
// More info: https://www.draftail.org/docs/entities
// Source -> React component for editing/deleting
// Decorator -> How to show the entity in editor.
import React from "react";
import { ENTITY_TYPE } from "draftail";
import LinkSource from "../sources/link";
import LinkDecorator from "../decorators/link";

const ENTITY_TYPE_LINK = {
  type: ENTITY_TYPE.LINK,
  icon: <i className="fa fa-link" />,
  source: LinkSource,
  decorator: LinkDecorator,
};

export default ENTITY_TYPE_LINK;
